export const DEPRECATED_ALIASES = {
  ModuleDeclaration: "ImportOrExportDeclaration",
};
